(function () {
    'use strict';

    angular
        .module('Directives')
        .directive('isInvalid', isInvalid);

    function isInvalid($q, $timeout) {
        return {
            restrict: 'A',
            scope: {
                isInvalid: '=?',
                async: '=?'
            },
            require: 'ngModel',
            link: function(scope, elem, attr, ngModel) {
                var aborter;
                function asyncValidator(modelValue, viewValue){
                    var defer = $q.defer();
                    if(aborter){
                        $timeout.cancel(aborter);
                    }
                    aborter = $timeout(function(){
                        try{
                            scope.isInvalid(modelValue).then(function(data){
                                if(data){
                                    defer.reject();
                                }else{
                                    defer.resolve();
                                }
                            });
                        }catch(e){
                            throw "pass promise on async";
                        }
                    },300);
                    return defer.promise;
                };
                function validator(modelValue){
                    $timeout(function(){
                        ngModel.$setValidity('isInvalid',
                            typeof(scope.isInvalid) === 'function' ? !scope.isInvalid(modelValue) : !scope.isInvalid);
                    });
                };
                if(!scope.async){
                    scope.$watch('isInvalid',validator);
                    scope.$watch('hasWarning',validator);
                }
                if(scope.async){
                    ngModel.$asyncValidators.isInvalid = asyncValidator;
                }
            }
        };
    };

})();







// WEBPACK FOOTER //
// ./js/directives/isInvalidDirective.js